'use client';

import Button from '@egalite/ui/Buttons';
import Icon from '@egalite/ui/Icon';
import Typography from '@egalite/ui/Typography';
import dynamic from 'next/dynamic';
import React, { useState, useEffect, ReactNode, FC } from 'react';

// add-to-calendar-button é um pacote de ~1 MB e o botão (web component) só
// materializa no cliente. Carregado sob demanda para ficar fora do bundle
// inicial da home, mesmo padrão já usado no Schedule (commit ecd2454).
const AddToCalendarButton = dynamic(
  () => import('add-to-calendar-button-react').then((m) => m.AddToCalendarButton),
  { ssr: false },
);

type timeBoxProps = {
  num: number, label:string
}
const TimeBox: FC<timeBoxProps> = ({ num = 0, label = 'date' }) => (
  <div className='flex flex-col gap-2 w-[60px] h-[64px] rounded-lg bg-brand-dark text-white items-center justify-center'>
    <div className='font-bold text-2xl'>{String(num).padStart(2, '0')}</div>
    <div className='text-xs font-light uppercase'>{label}</div>
  </div>
)

type Props = {
	children?: ReactNode;
};

const EventCountdown: FC<Props> = () => {

  const targetDate = new Date(2026, 8, 1, 10, 0, 0);

  const calculateTimeLeft = () => {
    const difference = +targetDate - +new Date();
    let timeLeft = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    // Limpa o intervalo quando o componente é desmontado
    return () => clearInterval(timer);
  }, []);

  // Função auxiliar para formatar números com dois dígitos
  //const formatTime = (num: number) => String(num).padStart(2, '0');

  // Quando o evento começa, a home passa a destacar a transmissão ao vivo;
  // o banner zerado sai do ar sozinho em vez de ficar em 00:00:00:00 até
  // alguém comentar o componente, como aconteceu na edição de 2025.
  const isTimeUp = +targetDate - +new Date() <= 0;
  if (isTimeUp) return null;

  return(
    <div className="flex flex-col items-center md:justify-center md:flex-row bg-brand-main min-h-[96px] w-full py-4 justify-between">
      <div className="flex flex-col w-full items-center md:items-start md:w-6/12 mb-12 md:mb-0 mt-4">
        <Typography variant="headline-5" color='white'>Não perca a abertura da 7ª edição da IncluiPcD</Typography>
        <Typography variant="body-3" color='white' className='flex gap-2 items-center -ml-2'><Icon name="calendar" className='h-[32px] w-[32px]' /><span>01 e 02/09/2026 • a partir das 10:00</span></Typography>
      </div>
      <div className='flex flex-col gap-8 md:flex-row items-center justify-center md:justify-end md:w-5/12'>
        <div className='flex gap-2 items-center text-white font-bold text-md'>
          <TimeBox num={timeLeft.days} label='dias' />
          <span>:</span>
          <TimeBox num={timeLeft.hours} label='horas' />
          <span>:</span>
          <TimeBox num={timeLeft.minutes} label='min' />
          <span>:</span>
          <TimeBox num={timeLeft.seconds} label='seg' />
        </div>
        <AddToCalendarButton
            name={'Evento IncluiPcD'}
            startDate={'2026-09-01'}
            endDate={'2026-09-02'}
            startTime={'10:00'}
            endTime={'18:00'}
            timeZone="America/Sao_Paulo"
            location="https://www.incluipcd.com.br"
            options={['Google', 'Outlook.com', 'iCal|Arquivo para todos os calendários']}
            label="Garanta sua vaga!"
            trigger="click"
            listStyle='modal'
            pastDateHandling='hide'
            buttonStyle='round'
            styleLight="--btn-text: rgb(15 29 215); --btn-background: #fff; --font: var(--font-inter); --btn-shadow: none; --btn-shadow-hover: none; --btn-text-hover: #fff; --btn-background-hover: rgb(44, 30, 91);"
            styleDark="--btn-background: rgb(15 29 215); --btn-text: #fff; --font: var(--font-inter); --btn-shadow: none; --btn-shadow-hover: none; --btn-text-hover: #fff; --btn-background-hover: rgb(44, 30, 91);"
            language='pt'
          />
      </div>
    </div>
  );
};

export default EventCountdown;